<section class="shared-order-modal">
  <div class="shared-title">
    {{sharedCreated ? sharedOrderText.scanQR : sharedOrderText.modalMain}}
  </div>
  <div *ngIf="sharedOrder && restaurant.enableSharedOrderSingleOrderReceivedSms && !sharedCreated" class="shared-content">
    <div class="shared-desc">
      {{sharedOrderText.receiveNumber}}
    </div>
    <app-verify-phone-number></app-verify-phone-number>
  </div>
  <div class="share-wrap" *ngIf="sharedCreated">
    <qrcode cssClass="qr-styles"
            [qrdata]="shareQrLink"
            [allowEmptyString]="true"
            [errorCorrectionLevel]="'Q'"
            [elementType]="'canvas'"
            colorDark="#000000"
            margin="0"
            width="200px"></qrcode>

    <div class="shared-info-wrap">
      <div class="shared-text">
        {{shareQrLink}}
      </div>
      <button mat-icon-button color="primary" (click)="copySharedUrl()">
        <mat-icon>content_copy</mat-icon>
      </button>
    </div>
  </div>
  <div class="action-wrap" *ngIf="!sharedOrder">
    <button class="footer-button cancel-btn" (click)="removeSharedOrder()">No</button>
    <button class="footer-button" (click)="sharedOrder = true">Yes</button>
  </div>
  <div class="action-wrap action-container" *ngIf="sharedOrder">
    <mat-progress-bar class="spinner" *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
    <button class="footer-button" (click)="createSharedOrder()">{{sharedCreated ? 'Close' : 'Share order'}}</button>
  </div>
</section>
